/**
 * Site Module
 */

import Axios from 'axios'

const state = {
  /**
   * site adatok
   *
   *  @type {
   *    {
   *      id: Number,
   *      logoSrc: String,
   *      siteName: String,
   *      isFoxpostApmSelectType: Boolean,
   *      isShopSite: Boolean,
   *      isBlogSite: Boolean,
   *      isCatalogPage: Boolean,
   *      isMenuHorizontalStyle: Boolean,
   *      domainDateFormat: String,
   *      privacyPolicyLink: String,
   *      privacyPolicyTitle: String,
   *      siteTitle: String,
   *      isBodyBuilder: Boolean,
   *      isFirstNameFirst: Boolean,
   *      canUsePointsInCheckout: Boolean,
   *      footer: {
   *        leftItemList: [
   *          {
   *            id: Number,
   *            name: String,
   *            link: String,
   *            isOuterLink: Boolean,
   *            isPhoneNumber: Boolean,
   *            isEmail: Boolean,
   *            isNoFollow: Boolean,
   *          },
   *        ],
   *        middleItemList: [
   *          {
   *            id: Number,
   *            name: String,
   *            link: String,
   *            isOuterLink: Boolean,
   *            isPhoneNumber: Boolean,
   *            isEmail: Boolean,
   *            isNoFollow: Boolean,
   *          },
   *        ],
   *        rightItemList: [
   *          {
   *            id: Number,
   *            name: String,
   *            link: String,
   *            isOuterLink: Boolean,
   *            isPhoneNumber: Boolean,
   *            isEmail: Boolean,
   *            isNoFollow: Boolean,
   *          },
   *        ],
   *        socialItemList: [
   *          {
   *            id: Number,
   *            name: String,
   *            link: String,
   *            isOuterLink: Boolean,
   *            isPhoneNumber: Boolean,
   *            isEmail: Boolean,
   *            isNoFollow: Boolean,
   *            contentType: String,
   *          },
   *        ],
   *        isMailSubscriberVisible: Boolean,
   *        isEmailBoxActive: Boolean,
   *        isEmailBoxDefaultOpen: Boolean,
   *        isShopFinderActive: Boolean,
   *        topLeftText: String,
   *        topRightText: String,
   *        bottomLeftText: String,
   *        bottomRightText: String,
   *        slogen: String,
   *      }|null,
   *      isFooterExists: Boolean,
   *      hasNewsLetter: Boolean,
   *      newsletterName: String|null,
   *      leftBlockText: String,
   *      middleBlockText: String,
   *      rightBlockText: String,
   *      siteHost: String,
   *    } | null
   *  }
   */
  site: null,
  /**
   * be van-e töltve a site adat
   */
  isSiteLoadDone: false,
  defaultDomainDateFormat: 'YYYY-MM-DD',
  /**
   * oldalhoz tartozo translationok betöltúdtek-e már
   *
   * @type {Boolean}
   */
  isTranslationsInitDone: false,
}

const getters = {
  getIsTranslationsInitDone: state => {
    return state.isTranslationsInitDone
  },
  /**
   * site adatok getter
   *
   * @param state
   * @return {{id: Number, logoSrc: String, siteName: String, isShopSite: Boolean, isBlogSite: Boolean, isCatalogPage: Boolean, isMenuHorizontalStyle: Boolean, domainDateFormat: String, privacyPolicyLink: String, privacyPolicyTitle: String, siteTitle: String, isBodyBuilder: Boolean, isFirstNameFirst: Boolean, canUsePointsInCheckout: Boolean, footer: ({leftItemList: {id: Number, name: String, link: String, isOuterLink: Boolean, isPhoneNumber: Boolean, isEmail: Boolean, isNoFollow: Boolean}[], middleItemList: {id: Number, name: String, link: String, isOuterLink: Boolean, isPhoneNumber: Boolean, isEmail: Boolean, isNoFollow: Boolean}[], rightItemList: {id: Number, name: String, link: String, isOuterLink: Boolean, isPhoneNumber: Boolean, isEmail: Boolean, isNoFollow: Boolean}[], socialItemList: {id: Number, name: String, link: String, isOuterLink: Boolean, isPhoneNumber: Boolean, isEmail: Boolean, isNoFollow: Boolean, contentType: String}[], isMailSubscriberVisible: Boolean, isEmailBoxActive: Boolean, isEmailBoxDefaultOpen: Boolean, isShopFinderActive: Boolean, topLeftText: String, topRightText: String, bottomLeftText: String, bottomRightText: String, slogen: String}|null), isFooterExists: Boolean, hasNewsLetter: Boolean, newsletterName: (String|null), leftBlockText: String, middleBlockText: String, rightBlockText: String, siteHost: String}}
   */
  getSite: state => {
    return state.site
  },
  getHasNewsLetter: state => {
    return state.site.hasNewsLetter
  },
  getNewsletterName: state => {
    return state.site.newsletterName
  },
  isBodyBuilder: state => {
    return state.site.isBodyBuilder
  },
  getPrivacyPolicyLink: state => {
    return state.site.privacyPolicyLink
  },
  getPrivacyPolicyTitle: state => {
    return state.site.privacyPolicyTitle
  },
  getSiteTitle: state => {
    return state.site.siteTitle
  },
  /**
   * @param state
   * @return {{
   * leftItemList:
   *  {
   *    id: Number,
   *    name: String,
   *    link: String,
   *    isOuterLink: Boolean,
   *    isPhoneNumber: Boolean,
   *    isEmail: Boolean,
   *    isNoFollow:
   *    Boolean
   *  }[],
   * middleItemList:
   *  {
   *    id: Number,
   *    name: String,
   *    link: String,
   *    isOuterLink: Boolean,
   *    isPhoneNumber: Boolean,
   *    isEmail: Boolean,
   *    isNoFollow: Boolean
   *  }[],
   * rightItemList:
   *  {
   *    id: Number,
   *    name: String,
   *    link: String,
   *    isOuterLink: Boolean,
   *    isPhoneNumber: Boolean,
   *    isEmail: Boolean,
   *    isNoFollow: Boolean
   *  }[],
   *  isMailSubscriberVisible: Boolean
   * }}
   */
  getFooter: state => {
    return state.site.footer
  },
  getIsFoxpostApmSelectType: state => {
    return state.site.isFoxpostApmSelectType
  },
  getIsFooterExists: state => {
    return state.site.isFooterExists
  },
  getMenuItems: state => {
    return state.site.menuItems
  },
  getSocialList: state => {
    return state.site.footer.socialItemList
  },
  getSiteName: state => {
    return state.site.siteName
  },
  getSiteHost: state => {
    return state.site.siteHost
  },
  getIsCatalogPage: state => {
    return state.site.isCatalogPage
  },
  getIsFirstNameFirst: state => {
    return state.site.isFirstNameFirst
  },
  getIsBlogSite: state => {
    return state.site.isBlogSite
  },
  /**
   * bodybuilderre termék ajánlóhoz termék adatok listája
   *
   * @return {[{
   *   id: Number,
   *   imageSrc: String,
   *   name: String,
   *   packaging: String,
   *   url: String,
   *   brandName: String,
   *   brandUrl: String,
   *   rating: Number,
   *   price: Number,
   *   priceFormatted: String,
   *   isDiscounted: Boolean,
   *   originalPrice: Number,
   *   originalPriceFormatted: String,
   *   giftPoint: Number,
   *   discountPercent: Number,
   *   orderable: Boolean,
   *   isNewItem: Boolean,
   *   showAddToCartBtn: Boolean,
   *   dataLayerData: Object,
   *   flavor: String,
   *   color: String,
   *   size: String,
   *   other: String,
   *   defaultSize: String,
   *   anchorTarget: String,
   * },]}
   */
  getBodyBuilderFooterOfferList: state => {
    return state.site.bodyBuilderFooterOfferList
  },
  /**
   * domain date format string, ha nincs betöltve még, akkor default
   *
   * @param state
   * @return {String|string}
   */
  getDomainDateFormat: state => {
    return state.isSiteLoadDone ? state.site.domainDateFormat : state.defaultDomainDateFormat
  },
  /**
   * be van-e töltve a site adat
   *
   * @param state
   * @returns {null}
   */
  isSiteLoadDone: state => {
    return state.isSiteLoadDone
  },
  isSiteSet: state => {
    return state.site !== null
  },
}

const actions = {
  init({ dispatch }) {
    return Promise.all([
      dispatch('loadSite'),
    ])
  },

  /**
   * mega menu betöltése
   *
   * @param commit
   * @return {Promise<AxiosResponse<any>>}
   */
  loadSite({ commit }) {
    return Axios.get('Shop/api/getSiteData')
      .then(({ data }) => {
        commit('setSite', data)
        commit('setIsSiteLoadDone', true)
      })
      .catch((error) => {
        commit('setSite', null)
        commit('setIsSiteLoadDone', false)
        console.error(error)
      })
  },
  /**
   * oldalhoz tartozo translate init kész van-e
   *
   * @param commit
   * @param payload
   */
  setIsTranslationsInitDone({ commit }, payload) {
    commit('setIsTranslationsInitDone', payload)
  },
}

const mutations = {
  /**
   * @param state
   * @param payload
   */
  setSite(state, payload) {
    state.site = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsSiteLoadDone(state, payload) {
    state.isSiteLoadDone = payload
  },
  setIsTranslationsInitDone(state, payload) {
    state.isTranslationsInitDone = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
